module.exports = __webpack_public_path__ + "static/media/logo.a6958ce7.svg";